import { render, staticRenderFns } from "./ImportEmailsDialog.vue?vue&type=template&id=27854eb2&scoped=true"
import script from "./ImportEmailsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportEmailsDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ImportEmailsDialog.vue?vue&type=style&index=0&id=27854eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27854eb2",
  null
  
)

export default component.exports